import { FETCH_MERCHANDISES, FETCH_MERCHANDISES_SUCCESS, FETCH_MERCHANDISES_FAILURE } from '../actions';

const initialState = {
  merchandises: [],
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_MERCHANDISES:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_MERCHANDISES_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        merchandises: action.data
      };
    case FETCH_MERCHANDISES_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        merchandises: []
      };
    default:
      return state;
  }
}